// extracted by mini-css-extract-plugin
module.exports = {"show-password-icon":"_BasicInformationBox_show-password-icon_YItGO"};